import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useQuery, useMutation } from "graphql-hooks";
import { useQueryClient } from "react-query";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { project_url, admin_string, welcome_page_text } from "../../constants/Data";
import {
  Card,
  CardContent,
  Container,
  Divider,
  Link,
  Typography,
  Button,
  FormHelperText,
  TextField,
  makeStyles,
} from "@material-ui/core";
import Box from "@mui/material/Box";
import AlertDialog from "../../components/AlertDialog.js";
import logoImg from "../../assets/logo.png";
import { CREATE_USER_MUTATION } from "../../graphQL/register_qry";

import { Visibility, VisibilityOff } from "@mui/icons-material";
import { InputAdornment, IconButton } from "@mui/material";

const useStyles = makeStyles(theme => ({
  cardContainer: {
    paddingBottom: 80,
    paddingTop: 40,
    maxWidth: 910,
    minHeight: 468,
  },
  cardContainerTablet: {
    paddingBottom: 38,
    paddingTop: 68,
    paddingLeft: 48,
    paddingRight: 48,
    //maxWidth: 672,
    height: 956,
  },
  cardContent: {
    padding: theme.spacing(4),
    display: "flex",
    flexDirection: "column",
    // paddingTop: 40,
    minHeight: 400,
    maxWidth: 430,
    //  minWidth: 310,
  },
  cardContentTablet: {
    padding: theme.spacing(4),
    display: "flex",
    flexDirection: "column",
    minHeight: 956,
  },
  cardTablet: {
    display: "flex",
    flexDirection: "column",
    minHeight: 956,
  },
  cardMobile: {
    display: "flex",
    flexDirection: "column",
    minHeight: 768,
  },
  cardContentMobile: {
    padding: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    paddingTop: 40,
    minHeight: 400,
    //  maxWidth: 700,
  },
  autoComStyleMobile: {
    "& .MuiInputLabel-outlined": {
      fontSize: 14,
    },
    "& .MuiFormControl-marginNormal": {
      marginTop: 30,
      marginBottom: 5,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      fontSize: 14,
    },
  },
  autoComStyle: {
    "& .MuiFormControl-marginNormal": {
      marginTop: 30,
      marginBottom: 5,
      "& .MuiInputLabel-outlined": {
        fontSize: 16,
      },
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      fontSize: 16,
    },
  },
  textFieldStyle: {
    marginBottom: 5,
    marginTop: 30,
    "& .MuiInputLabel-outlined": {
      fontSize: 16,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      fontSize: 16,
    },
  },
  textFieldStyleError: {
    marginBottom: 5,
    marginTop: 30,
    borderColor: "#D32F2F",
    borderWidths: 3,
    "& .MuiInputLabel-outlined": {
      fontSize: 16,
      borderColor: "#D32F2F",
      borderWidths: 3,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      borderColor: "#D32F2F",
      borderWidths: 3,
      fontSize: 16,
    },
  },
  textFieldStyleMobile: {
    marginBottom: 5,
    marginTop: 30,
    "& .MuiInputLabel-outlined": {
      fontSize: 14,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      fontSize: 14,
    },
  },
  errorStyle: {
    marginTop: 0,
    fontSize: 14, //16,
    fontFamily: "Arial",
  },
  errorStyleMobile: {
    marginTop: 0,
    fontSize: 12,
    fontFamily: "Arial",
  },
  successStyle: {
    color: "#212121",
    backgroundColor: "#F0FEF4",
    borderRadius: 12,
    padding: 16,
    fontSize: 16,
    fontFamily: "Arial",
    lineHeight: 1.4,
  },
  successStyleMobile: {
    color: "#212121",
    backgroundColor: "#F0FEF4",
    borderRadius: 12,
    padding: 16,
    fontSize: 14,
    fontFamily: "Arial",
    lineHeight: 1.4,
  },
  buttonStyle: {
    borderRadius: 12,
    width: "158px",
    height: "48px",
    textTransform: "none",
    "&:active": {
      backgroundColor: "#0D47A1",
    },
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
}));

const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));

const Registration = () => {
  const classes = useStyles();
  const [state, setState] = useState({
    mobileView: false,
    tabletView: false,
  });

  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors },
    getValues,
  } = useForm();

  const { mobileView, tabletView } = state;
  // useEffect(() => {
  //   const setResponsiveness = () => {
  //     return window.innerWidth < 768
  //       ? setState(() => ({ mobileView: true }))
  //       : window.innerWidth < 821 && window.innerWidth > 767
  //       ? setState(() => ({ mobileView: false, tabletView: true }))
  //       : setState(() => ({ tabletView: false }));
  //   };
  //   setResponsiveness();
  //   window.addEventListener("resize", () => setResponsiveness());
  //   return () => {
  //     window.removeEventListener("resize", () => setResponsiveness());
  //   };
  // }, []);
  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [options, setOptions] = useState([]);
  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [tenantName, setTenantName] = useState("");
  const [password, setPassword] = useState("");
  const [repeatPassword, setRepeatPassword] = useState("");

  const [createUser] = useMutation(CREATE_USER_MUTATION);

  const [showPassword, setShowPassword] = useState(false);
  const [showRepeatPassword, setShowRepeatPassword] = useState(false);

  const handleTogglePassword = () => {
    setShowPassword((prev) => !prev);    
  };

  const handleToggleRepeatPassword = () => {
    setShowRepeatPassword((prev) => !prev);    
  };

  /*
   * Function : setTimeout
   * Description : Disappear message after timeout
   */
  setTimeout(() => {
    setSuccessMsg("");
    // setErrorMsg("");
  }, 15000);

  const onSubmit = async formData => {
    if (formData.password === formData.repeatPassword) {
      // await sleep(2000);
      console.log(formData);
      const { data, error } = await createUser({
        variables: {
          email: formData.email,
          firstName: formData.firstName,
          lastName: formData.lastName,
          tenantName: formData.tenantName,
          password: formData.password,
          repeatPassword: formData.repeatPassword,
        },
      });

      if (error) {
        console.log("Error", error, data);
        setErrorMsg(error.graphQLErrors[0].message);
        //  setTimeout("");
      } else {
        console.log("Success");
        setSuccessMsg(
          "You must activate your account via email notification you will receive."
        );
        // setTimeout("");
        // Sahar RTS-1093
        localStorage.setItem("userRegisterEmail", formData.email);
        //
        navigate(`${project_url}/register_success`);
      }
    } else alert("Password and its repeat must be the same");
  };

  const errorMsgDlgClose = e => {
    setErrorMsg("");
  };

  let areAllFieldsFilled = false;
  useEffect(() => {
    console.log("useEffect");
    areAllFieldsFilled = email != "" && firstName != "" && lastName != "" && tenantName != "" && password != "" && repeatPassword != "";
    console.log(areAllFieldsFilled);
  }, []);

  return (
    <>
      <title>APIE | Registration</title>
      {mobileView && (
        <Card className={classes.cardMobile}>
          <CardContent className={classes.cardContentMobile}>
            <Box alignItems="center" mb={3} flexGrow={1}>
              <Box
                flexGrow={1}
                alignItems="center"
                display="flex"
                justifyContent="space-between"
              >
                <div>
                  <Typography gutterBottom variant="subtitle2">
                    Register Tenant
                  </Typography>
                </div>
              </Box>
              <Box flexGrow={1} alignItems="center" display="flex" justifyContent="space-between">
                  <Typography variant="h3">
                      This page is to create and register a new Tenant. 
                      If you are a user, go to the 
                      <Link component={RouterLink} to={ project_url + "/signin" }  variant="h2" color="primary">
                        &nbsp;Sign-in
                      </Link> page.
                    </Typography>
                </Box> 

              <Typography variant="body2">{welcome_page_text}</Typography>
            </Box>
            <form onSubmit={handleSubmit(onSubmit)} novalidate>
              <Box flexGrow={1} mb={1}>

                <TextField
                  className={classes.textFieldStyleMobile}
                  fullWidth
                  autoFocus
                  label="First Name" // Address"
                  margin="normal"
                  name="firstName"
                  type="firstName"
                  variant="outlined"
                  id="firstName"
                  {...register("firstName", {
                    required: true                    
                  })}
                />

                {errors.firstName && errors.firstName.type === "required" && (
                  <Box ml={2}>
                    <FormHelperText className={classes.errorStyleMobile} error>
                      First Name cannot be blank.
                    </FormHelperText>
                  </Box>
                )}

                <TextField
                  className={classes.textFieldStyleMobile}
                  fullWidth
                  //autoFocus
                  label="Last Name" // Address"
                  margin="normal"
                  name="lastName"
                  type="lastName"
                  variant="outlined"
                  id="lastName"
                  {...register("lastName", {
                    required: true                    
                  })}
                />

                {errors.lastName && errors.lastName.type === "required" && (
                  <Box ml={2}>
                    <FormHelperText className={classes.errorStyleMobile} error>
                      Last Name cannot be blank.
                    </FormHelperText>
                  </Box>
                )}

                <TextField
                  className={classes.textFieldStyleMobile}
                  fullWidth
                  //autoFocus
                  label="Email" // Address"
                  margin="normal"
                  name="email"
                  type="email"
                  variant="outlined"
                  id="email"
                  {...register("email", {
                    required: true,
                    pattern: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                  })}
                />

                {errors.email && errors.email.type === "required" && (
                  <Box ml={2}>
                    <FormHelperText className={classes.errorStyleMobile} error>
                      Email address cannot be blank.
                    </FormHelperText>
                  </Box>
                )}
                {errors.email && errors.email.type === "pattern" && (
                  <Box ml={2}>
                    <FormHelperText className={classes.errorStyleMobile} error>
                      Enter a correctly-formed email like myname@xyz.com
                    </FormHelperText>
                  </Box>
                )}

                <TextField
                  className={classes.textFieldStyleMobile}
                  fullWidth
                  label="Password"
                  margin="normal"
                  name="password"
                  type={showPassword ? "text" : "password"}                  
                  variant="outlined"
                  id="password"
                  
                  {...register("password", { required: true })}
                   InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={handleTogglePassword}
                            edge="end"
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                />
                {errors.password && errors.password.type === "required" && (
                  <Box ml={2}>
                    <FormHelperText className={classes.errorStyleMobile} error>
                      Password cannot be blank.
                    </FormHelperText>
                  </Box>
                )}

                <TextField
                  className={classes.textFieldStyleMobile}
                  fullWidth
                  label="Repeat Password"
                  margin="normal"
                  name="repeatPassword"
                  type={showRepeatPassword ? "text" : "password"} 
                  variant="outlined"
                  id="repeatPassword"
                  
                  {...register("repeatPassword", {
                    required: true,
                    validate: value => {
                      const { password } = getValues();
                      return password === value;
                    },
                  })}

                   InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={handleToggleRepeatPassword}
                            edge="end"
                          >
                            {showRepeatPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                />
                {errors.repeatPassword && errors.repeatPassword.type === "required" && (
                  <Box ml={2}>
                    <FormHelperText className={classes.errorStyleMobile} error>
                      Repeat Password cannot be blank
                    </FormHelperText>
                  </Box>
                )}
                {errors.repeatPassword && errors.repeatPassword.type === "validate" && (
                  <Box ml={2}>
                    <FormHelperText className={classes.errorStyleMobile} error>
                      Password and Repeat Password dose not match
                    </FormHelperText>
                  </Box>
                )}
                {!errors.repeatPassword && (
                  <Box ml={2}>
                    <Typography variant="h6">Enter your password again</Typography>
                  </Box>
                )}

                <TextField
                  className={classes.textFieldStyleMobile}
                  fullWidth
                  //autoFocus
                  label="Your Tenant Name" // Address"
                  margin="normal"
                  name="tenantName"
                  type="tenantName"
                  variant="outlined"
                  id="tenantName"
                  {...register("tenantName", {
                    required: true                    
                  })}
                />

                {errors.tenantName && errors.tenantName.type === "required" && (
                  <Box ml={2}>
                    <FormHelperText className={classes.errorStyleMobile} error>
                      Tenant Name cannot be blank.
                    </FormHelperText>
                  </Box>
                )}
                
                {successMsg && (
                  <Box mt={2} className={classes.successStyleMobile}>
                    {successMsg}
                  </Box>
                )}
                <Box mt={5} display="flex" justifyContent="center">
                  <Button
                    className={classes.buttonStyle}
                    color="primary"
                    type="submit"
                    variant="contained"
                  >
                    Submit
                  </Button>
                </Box>
              </Box>
              <Box mt={2} mb={2} display="flex" alignItems="center">
                <Typography variant="h5">Already have an account?</Typography>
                <Box ml={0.5}>
                  <Link
                    component={RouterLink}
                    to={ project_url + "/signin" }
                    variant="h4"
                    color="primary"
                  >
                    Sign in
                  </Link>
                </Box>
              </Box>
            </form>
          </CardContent>
        </Card>
      )}
      {tabletView && (
        <Container className={classes.cardContainerTablet}>
          <Card className={classes.cardTablet}>
            <CardContent className={classes.cardContentTablet}>
              <Box alignItems="center" mb={3} flexGrow={1}>
                <Box
                  flexGrow={1}
                  alignItems="center"
                  display="flex"
                  justifyContent="space-between"
                >
                  <div>
                    <Typography gutterBottom variant="subtitle1">
                      Register Tenant
                    </Typography>
                  </div>
                </Box>
                <Box flexGrow={1} alignItems="center" display="flex" justifyContent="space-between">
                  <Typography variant="h3">
                      This page is to create and register a new Tenant. 
                      If you are a user, go to the 
                      <Link component={RouterLink} to={ project_url + "/signin" }  variant="h2" color="primary">
                        &nbsp;Sign-in
                      </Link> page.
                    </Typography>
                </Box>
                <Typography variant="body1">{welcome_page_text}</Typography>
              </Box>
              <form onSubmit={handleSubmit(onSubmit)}>
                <Box flexGrow={1} mb={1}>

                  <TextField
                    className={classes.textFieldStyle}
                    fullWidth
                    autoFocus
                    label="First Name" // Address"
                    margin="normal"
                    name="firstName"
                    type="firstName"
                    variant="outlined"
                    id="firstName"
                    {...register("firstName", {
                      required: true
                    })}
                  />
                  {errors.firstName && errors.firstName.type === "required" && (
                    <Box ml={2}>
                      <FormHelperText className={classes.errorStyleMobile} error>
                        First Name cannot be blank.
                      </FormHelperText>
                    </Box>
                  )}

                  <TextField
                    className={classes.textFieldStyle}
                    fullWidth
                    //autoFocus
                    label="Last Name" // Address"
                    margin="normal"
                    name="lastName"
                    type="lastName"
                    variant="outlined"
                    id="lastName"
                    {...register("lastName", {
                      required: true
                    })}
                  />
                  {errors.lastName && errors.lastName.type === "required" && (
                    <Box ml={2}>
                      <FormHelperText className={classes.errorStyleMobile} error>
                        Last Name cannot be blank.
                      </FormHelperText>
                    </Box>
                  )}

                  <TextField
                    className={classes.textFieldStyle}
                    fullWidth
                    //autoFocus
                    label="Email" // Address"
                    margin="normal"
                    name="email"
                    type="email"
                    variant="outlined"
                    id="email"
                    {...register("email", {
                      required: true,
                      pattern: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                    })}
                  />
                  {errors.email && errors.email.type === "required" && (
                    <Box ml={2}>
                      <FormHelperText className={classes.errorStyleMobile} error>
                        Email address cannot be blank.
                      </FormHelperText>
                    </Box>
                  )}
                  {errors.email && errors.email.type === "pattern" && (
                    <Box ml={2}>
                      <FormHelperText className={classes.errorStyleMobile} error>
                        Enter a correctly-formed email like myname@xyz.com
                      </FormHelperText>
                    </Box>
                  )}

                  <TextField
                  className={classes.textFieldStyleMobile}
                  fullWidth
                  label="Password"
                  margin="normal"
                  name="password"
                  type={showPassword ? "text" : "password"}                  
                  variant="outlined"
                  id="password"
                  
                  {...register("password", { required: true })}
                   InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={handleTogglePassword}
                            edge="end"
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                />
                  {errors.password && errors.password.type === "required" && (
                    <Box ml={2}>
                      <FormHelperText className={classes.errorStyleMobile} error>
                        Password cannot be blank.
                      </FormHelperText>
                    </Box>
                  )}
                  <TextField
                  className={classes.textFieldStyleMobile}
                  fullWidth
                  label="Repeat Password"
                  margin="normal"
                  name="repeatPassword"
                  type={showRepeatPassword ? "text" : "password"} 
                  variant="outlined"
                  id="repeatPassword"
                  
                  {...register("repeatPassword", {
                    required: true,
                    validate: value => {
                      const { password } = getValues();
                      return password === value;
                    },
                  })}

                   InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={handleToggleRepeatPassword}
                            edge="end"
                          >
                            {showRepeatPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                />
                  {errors.repeatPassword && errors.repeatPassword.type === "required" && (
                    <Box ml={2}>
                      <FormHelperText className={classes.errorStyleMobile} error>
                        Repeat Password cannot be blank
                      </FormHelperText>
                    </Box>
                  )}
                  {errors.repeatPassword && errors.repeatPassword.type === "validate" && (
                    <Box ml={2}>
                      <FormHelperText className={classes.errorStyleMobile} error>
                        Password and Repeat Password dose not match
                      </FormHelperText>
                    </Box>
                  )}
                  {!errors.repeatPassword && (
                    <Box ml={2}>
                      <Typography variant="h6">Enter your password again</Typography>
                    </Box>
                  )}

                  <TextField
                    className={classes.textFieldStyle}
                    fullWidth
                    //autoFocus
                    label="Your Tenant Name" // Address"
                    margin="normal"
                    name="tenantName"
                    type="tenantName"
                    variant="outlined"
                    id="tenantName"
                    {...register("tenantName", {
                      required: true
                    })}
                  />
                  {errors.tenantName && errors.tenantName.type === "required" && (
                    <Box ml={2}>
                      <FormHelperText className={classes.errorStyleMobile} error>
                        Tenant Name cannot be blank.
                      </FormHelperText>
                    </Box>
                  )}
                  
                  {successMsg && (
                    <Box mt={2} className={classes.successStyle}>
                      {successMsg}
                    </Box>
                  )}
                  <Box mt={5} display="flex" justifyContent="center">
                    <Button
                      className={classes.buttonStyle}
                      color="primary"
                      type="submit"
                      variant="contained"
                    >
                      Submit
                    </Button>
                  </Box>
                </Box>
                <Box mt={2} mb={2} display="flex" alignItems="center">
                  <Typography variant="h3">Already have an account?</Typography>
                  <Box ml={0.5}>
                    <Link
                      component={RouterLink}
                      to={ project_url + "/signin" }
                      variant="h2"
                      color="primary"
                    >
                      Sign in
                    </Link>
                  </Box>
                </Box>
              </form>
            </CardContent>
          </Card>
        </Container>
      )}
      {!mobileView && !tabletView && (
        <Container className={classes.cardContainer} maxWidth="sm">
          <Card style={{ display: "flex", flexDirection: "row" }}>
            <CardContent className={classes.cardContent}>
              <Box alignItems="center" mb={3} flexGrow={1}>
                <Box mb={2}>
                  <img src={logoImg} alt="logo" />
                </Box>
                <Typography variant="body1">{welcome_page_text}</Typography>
              </Box>
            </CardContent>

            <Divider orientation="vertical" flexItem />
            <CardContent className={classes.cardContent} style={{ minWidth: 350 }}>
              <form onSubmit={handleSubmit(onSubmit)}>
                <Box
                  flexGrow={1}
                  alignItems="center"
                  display="flex"
                  justifyContent="space-between"
                >
                  <Typography
                    gutterBottom
                    variant="subtitle1"
                    style={{ fontSize: 34, fontWeight: 700, marginBottom: 0 }}
                  >
                    Register Tenant
                  </Typography>
                </Box>

                <Box flexGrow={1} alignItems="center" display="flex" justifyContent="space-between">
                  <Typography variant="h3">
                      This page is to create and register a new Tenant. 
                      If you are a user, go to the 
                      <Link component={RouterLink} to={ project_url + "/signin" }  variant="h2" color="primary">
                        &nbsp;Sign-in
                      </Link> page.
                    </Typography>
                </Box>

                <Box flexGrow={1} mb={1}>

                  <TextField
                    className={
                      errors.firstName ? classes.textFieldStyleError : classes.textFieldStyle
                    }
                    fullWidth
                    autoFocus
                    label="First Name" // Address"
                    margin="normal"
                    name="firstName"
                    type="firstName"
                    variant="outlined"
                    id="firstName"
                    onChange={e => setFirstName(e.target.value)}
                    {...register("firstName", {
                      required: true
                    })}
                  />
                  {errors.firstName && errors.firstName.type === "required" && (
                    <Box ml={2}>
                      <FormHelperText className={classes.errorStyleMobile} error>
                        First Name cannot be blank.
                      </FormHelperText>
                    </Box>
                  )}

                  <TextField
                    className={
                      errors.lastName ? classes.textFieldStyleError : classes.textFieldStyle
                    }
                    fullWidth
                    //autoFocus
                    label="Last Name" // Address"
                    margin="normal"
                    name="lastName"
                    type="lastName"
                    variant="outlined"
                    id="lastName"
                    onChange={e => setLastName(e.target.value)}
                    {...register("lastName", {
                      required: true
                    })}
                  />
                  {errors.lastName && errors.lastName.type === "required" && (
                    <Box ml={2}>
                      <FormHelperText className={classes.errorStyleMobile} error>
                        Last Name cannot be blank.
                      </FormHelperText>
                    </Box>
                  )}


                  <TextField
                    className={
                      errors.email ? classes.textFieldStyleError : classes.textFieldStyle
                    }
                    fullWidth
                    //autoFocus
                    label="Email" // Address"
                    margin="normal"
                    name="email"
                    type="email"
                    variant="outlined"
                    id="email"
                    onChange={e => setEmail(e.target.value)}
                    {...register("email", {
                      required: true,
                      pattern: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                    })}
                  />
                  {errors.email && errors.email.type === "required" && (
                    <Box ml={2}>
                      <FormHelperText className={classes.errorStyleMobile} error>
                        Email address cannot be blank.
                      </FormHelperText>
                    </Box>
                  )}
                  {errors.email && errors.email.type === "pattern" && (
                    <Box ml={2}>
                      <FormHelperText className={classes.errorStyleMobile} error>
                        Enter a correctly-formed email like myname@xyz.com
                      </FormHelperText>
                    </Box>
                  )}
                  <TextField
                  className={classes.textFieldStyleMobile}
                  fullWidth
                  label="Password"
                  margin="normal"
                  name="password"
                  type={showPassword ? "text" : "password"}                  
                  variant="outlined"
                  id="password"
                  
                  {...register("password", { required: true })}
                   InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={handleTogglePassword}
                            edge="end"
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                />
                  {errors.password && errors.password.type === "required" && (
                    <Box ml={2}>
                      <FormHelperText className={classes.errorStyleMobile} error>
                        Password cannot be blank.
                      </FormHelperText>
                    </Box>
                  )}
                  <TextField
                  className={classes.textFieldStyleMobile}
                  fullWidth
                  label="Repeat Password"
                  margin="normal"
                  name="repeatPassword"
                  type={showRepeatPassword ? "text" : "password"} 
                  variant="outlined"
                  id="repeatPassword"
                  
                  {...register("repeatPassword", {
                    required: true,
                    validate: value => {
                      const { password } = getValues();
                      return password === value;
                    },
                  })}

                   InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={handleToggleRepeatPassword}
                            edge="end"
                          >
                            {showRepeatPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                />
                  {errors.repeatPassword && errors.repeatPassword.type === "required" && (
                    <Box ml={2}>
                      <FormHelperText className={classes.errorStyleMobile} error>
                        Repeat Password cannot be blank
                      </FormHelperText>
                    </Box>
                  )}
                  {errors.repeatPassword && errors.repeatPassword.type === "validate" && (
                    <Box ml={2}>
                      <FormHelperText className={classes.errorStyleMobile} error>
                        Password and Repeat Password dose not match
                      </FormHelperText>
                    </Box>
                  )}

                   <TextField
                    className={
                      errors.tenantName ? classes.textFieldStyleError : classes.textFieldStyle
                    }
                    fullWidth
                    //autoFocus
                    label="Your Tenant Name" // Address"
                    margin="normal"
                    name="tenantName"
                    type="tenantName"
                    variant="outlined"
                    id="tenantName"
                    onChange={e => setTenantName(e.target.value)}
                    {...register("tenantName", {
                      required: true
                    })}
                  />
                  {errors.tenantName && errors.tenantName.type === "required" && (
                    <Box ml={2}>
                      <FormHelperText className={classes.errorStyleMobile} error>
                        Tenant Name cannot be blank.
                      </FormHelperText>
                    </Box>
                  )}

                  {successMsg && (
                    <Box mt={2} className={classes.successStyle}>
                      {successMsg}
                    </Box>
                  )}
                  <Box mt={5} display="flex" justifyContent="center">
                    <Button
                      className={classes.buttonStyle}
                      color="primary"
                      type="submit"
                      variant="contained"
                      formnovalidate
                    >
                      Submit
                    </Button>
                  </Box>
                </Box>
                <Box mt={2} mb={2} display="flex" alignItems="center">
                  <Typography variant="h3">Already have an account?</Typography>
                  <Box ml={0.5}>
                    <Link
                      component={RouterLink}
                      to={ project_url + "/signin" }
                      variant="h2"
                      color="primary"
                    >
                      Sign in
                    </Link>
                  </Box>
                </Box>
              </form>
            </CardContent>
          </Card>
        </Container>
      )}

      {errorMsg && (
        <AlertDialog title="Alert" closeDialog={errorMsgDlgClose} contentMsg={errorMsg} />
      )}
    </>
  );
};

export default Registration;
